import React from 'react'
import PropTypes from 'prop-types'
import StaticOverviewTableThead from "./StaticOverviewTableThead"
import StaticOverviewTableBody from "./StaticOverviewTableBody"
import {Spin} from "antd"

StaticOverviewTable.propTypes = {
    loading: PropTypes.bool,
    error: PropTypes.string,
    statics: PropTypes.array
}

function StaticOverviewTable(props) {
    const {statics, loading, error} = props

    return (
        <div className='StaticOverviewTable'>
            <Spin spinning={loading} tip="Đang lấy thông tin...">
                <table className="table table-bordered">
                    <StaticOverviewTableThead/>
                    <StaticOverviewTableBody statics={statics} error={error}/>
                </table>
            </Spin>
        </div>
    )
}

export default StaticOverviewTable
